(async function () {

	const bundle_raw_configuration = JSON.parse($('script#bundle-raw-configuration-json').html()) || {};
	const discount_tiers = {};
	const gift_variants = {};
	const gift_count = {};
	const tier_descriptions = {};

	Object.keys(bundle_raw_configuration?.tiers || {}).forEach(tier => {
		const tierNum = parseInt(tier);
		discount_tiers[tierNum] = parseFloat(bundle_raw_configuration.tiers[tier].discount) || 0;
		gift_variants[tierNum] = bundle_raw_configuration.tiers[tier].gift_variants || [];
		gift_count[tierNum] = parseInt(bundle_raw_configuration.tiers[tier].gift_count) || 0;
		tier_descriptions[tierNum] = bundle_raw_configuration.tiers[tier].description || '';
	});



	// Helper function to get current tier based on quantity
	function getCurrentTier($quantity) {
		$quantity = $quantity || $('.bb-item-active').length;
		const tiers = Object.keys(discount_tiers).sort((a, b) => b - a); // Sort tiers in descending order

		for (const tier of tiers) {
			if ($quantity - (gift_count[tier] || 0) >= parseInt(tier)) {
				return tier;
			}
		}

		return null;
	}

	function getItemText(count) {
		return count === 1 ? 'Item' : 'Items';
	}

	const strings = {
		'update_bundle_in_cart': 'UPDATE BUNDLE'
	};


	const bundle_key = new URL(window.location.href).searchParams.get('edit');

	const bundle_metadata = (() => {
		if (($('#free_bag_active').val() === true || $('#free_bag_active').val() === 'true')) {
			return {
				items: {
					[$('.bb-item-active').data('variant-id')]: { quantity: 1 }
				}
			};
		} else {
			return {
				items: {}
			};
		}
	})();

	const bundle_metadata_original = JSON.parse(JSON.stringify(bundle_metadata));

	// Edit mode
	// if(bundle_key && ($('#free_bag_active').val() === true || $('#free_bag_active').val() === 'true') && ! bundle_metadata_original.items[$('.bb-item-active').data('variant-id')]){
	// 	bundle_metadata_original.items[$('.bb-item-active').data('variant-id')] = {quantity: 1};
	// }

	let bundle_item;
	if (bundle_key) {
		const cart_data = await (await fetch('/?view=cart_js')).json();
		bundle_item = cart_data.items.find(item => item.key === bundle_key);
		if (bundle_item && Object.keys(bundle_item).length) {

			getStarted()

			setTimeout(function () {
				for (let item_component of bundle_item.item_components) {
					if ($(`.single-item-holder .variants-container input[data-variant-id="${item_component.id}"]:first`).length > 0) {
						for (let i = 0; i < item_component.quantity; i++) {
							$(`.single-item-holder .variants-container input[data-variant-id="${item_component.id}"]:first`).click();
							$(`.single-item-holder input[data-variant-id="${item_component.id}"]:first`).closest('.single-item-holder').find('.bb-add-product-bundle').click()
						}
					}
				}
			}, 1)
		}
	}


	// Hide/remove add button
	function showHideBundleActions(isEditMode = false){
		if(parseInt(document.getElementById('bundles_in_cart')?.value) >= (2 + (isEditMode ? 1 : 0))){
			document.querySelectorAll('.bundle-actions').forEach(node => {
				node.classList.add('hidden');
			})
		}else{
			document.querySelectorAll('.bundle-actions').forEach(node => {
				node.classList.remove('hidden');
			})
		}
	}

	showHideBundleActions(!!bundle_key);

	Shopify.formatMoney = function (cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '')
		}
		var value = '';
		var placeholderRegex = /{{\s*(\w+)\s*}}/;
		this.money_format = this.money_format || false;
		var formatString = format || this.money_format;
		var defaultOption = function (opt, def) {
			return (typeof opt === 'undefined' ? def : opt)
		};
		var formatWithDelimiters = function (number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal = defaultOption(decimal, '.');
			if (isNaN(number) || number == null) {
				return 0
			}
			number = (number / 100.0).toFixed(precision);
			var parts = number.split('.')
				, dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
				, cents = parts[1] ? (decimal + parts[1]) : '';
			return dollars + cents
		};
		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break
		}
		return formatString.replace(placeholderRegex, value)
	};



	function priceUpdate() {

		// Get the current tier based on quantity
		const currentTier = getCurrentTier();
		const hasFreeGift = currentTier && gift_count[currentTier] > 0;

		// Calculate total price of items
		let $price = 0;
		$('.bb-item-active').each(function () {
			const $id = $(this).data('variant-id');
			const $itemPrice = $('.bb-free-bag-item .card-variants-container input[data-variant-id="' + $id + '"]').data('price');
			$price += $itemPrice;
		});

		// Apply discount based on current tier
		const $priceChange = currentTier ? (1 - (discount_tiers[currentTier] / 100)) : 1;

		// Calculate original and discounted price
		let $originalPrice = $price;
		if (hasFreeGift) {
			const $giftItem = $('.bb-item-active[data-type="gift"]');
			const $giftPrice = $giftItem.length ?
				$('.bb-free-bag-item[data-variant-id="' + $giftItem.data('variant-id') + '"]').data('price') : 19;
			$originalPrice += $giftPrice;
		}

		const $newPrice = $priceChange * $price;
		const $amountSaved = $originalPrice - $newPrice;

		// Update display
		const $originalPriceFormatted = Shopify.formatMoney($originalPrice, '${{amount}}');
		const $priceFormatted = Shopify.formatMoney($newPrice, '${{amount}}');
		const $savingsFormatted = Shopify.formatMoney($amountSaved, '${{amount}}');

		if ($originalPrice > $newPrice) {
			$('.bb-original-price').html($originalPriceFormatted).show();
		} else {
			$('.bb-original-price').hide();
		}
		if($amountSaved <= 0) {
			$('.bb-discount').addClass('visually-hidden');
		} else {
			$('.bb-discount').removeClass('visually-hidden');
		}
		$('.bb-current-discount').html(discount_tiers[currentTier] + '%');
		$('.bb-amount-saved').html('-' + $savingsFormatted);
		$('.bb-discounted-price').html($priceFormatted);
		$('.bb-discounted-price').data('price', $newPrice);

	}

	// To show the correct variant image when an item with variants is added
	setTimeout(function(){
		document.querySelectorAll('.card-variants-container').forEach(node => {
			if(node.querySelectorAll('input[data-variant-id]')?.length > 1){
				node.querySelector('input[data-variant-id]:checked')?.dispatchEvent(new Event('change', { bubbles: true }))
			}
		})
	}, 3000)
	

	function getStarted() {
		var $offset = $('.bb-collection-container').offset().top;
		$('html, body').animate({
			'scrollTop': $offset
		});
	}

	function addNormalItem($this) {
		var $target = $this.closest('.bb-free-bag-item'),
			$variantId = $target.data('variant-id'),
			$variantName = $target.data('name'),
			$image = $target.data('image')	,
			$type = $target.data('type'),
			$title = $target.find('h3').html(),
			$price = $target.data('price');
		const currentQuantityInBundle = getBundleItemQuantity($variantId);
		const maxAllowedQuantity = parseInt($target.data('max')) || 2;
		if(currentQuantityInBundle <= 0) {
			$target.find('.quick-add').removeClass('bb-quantity-hidden');
		}
		if(currentQuantityInBundle + 1 == maxAllowedQuantity) {
			$this.addClass('bb-item-remove-cart');
			$target.find('.quick-add').addClass('bb-quantity-hidden');
		}
		if (maxAllowedQuantity > 0 && currentQuantityInBundle < maxAllowedQuantity) {
			$target.addClass('bb-added-to-bundle');
			$('.bb-added-item.bb-item-active + .bb-item-placeholder').html(' ');
			var html = '<a href="javascript:void(0)" class="remove-bb-item"><svg xmlns="http://www.w3.org/2000/svg" width="9.02" height="9.02" viewBox="0 0 9.02 9.02"><g id="Group_2535" data-name="Group 2535" transform="translate(0.354 0.353)"><path id="Path_1691" data-name="Path 1691" d="M-3487.372-4476.921l-8.312-8.313" transform="translate(3495.685 4485.234)" fill="none" stroke="#fff" stroke-width="1"/><path id="Path_1692" data-name="Path 1692" d="M8.312,8.313,0,0" transform="translate(8.313 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/></g></svg></a><div class="bb-added-item-image"><img src="' + $image + '" alt="" /></div><p class="bb-added-item-title">' + $title + '</p>';
			if ($('.bb-added-item.bb-item-active').length) {
				$('.bb-added-item.bb-item-active + .bb-item-placeholder').attr('data-variant-id', $variantId).attr('data-name', $variantName).attr('data-image', $image).attr('data-type', $type).html(html).removeClass('bb-item-placeholder').addClass('bb-item-active');
			} else {
				$('.bb-added-item.bb-item-placeholder:first-of-type').attr('data-variant-id', $variantId).attr('data-name', $variantName).attr('data-image', $image).attr('data-type', $type).html(html).removeClass('bb-item-placeholder').addClass('bb-item-active');
			}
			var $oldTotal = $('.bb-discounted-price').data('price');
			if ($oldTotal == undefined) {
				$newTotal = $oldTotal;
			} else {
				$newTotal = $oldTotal + $price;
			}
			priceUpdate();
			var $oldBundleProductsCount = parseInt($('#total_bundle_products').val());
			$newBundleProductsCount = $oldBundleProductsCount + 1;
			$countThresholdLimit = $newBundleProductsCount;
			$('#total_bundle_products').val($newBundleProductsCount);
			if($newBundleProductsCount == 1) {
				var $count_text = $newBundleProductsCount + ' Product';
			} else {
				var $count_text = $newBundleProductsCount + ' Products';
			}
			$('.bb_products_in_bundle').html($count_text);
			$('.bb-item-active h3 span').remove();

			// Determine the next tier to reach based on current count
			let $nextTier = null;
			let $discount = '';
			const sortedTiers = Object.keys(discount_tiers).sort((a, b) => a - b);

			for (const tier of sortedTiers) {
				if ($newBundleProductsCount < parseInt(tier)) {
					$nextTier = tier;
					$discount = discount_tiers[tier] + '%';
					break;
				}
			}
			// If we've reached the highest tier
			if (!$nextTier) {
				$nextTier = sortedTiers[sortedTiers.length];
				$discount = discount_tiers[$nextTier] + '%';
			}
			$countThreshold = parseInt($nextTier);
			$callActionCount = $countThreshold - $newBundleProductsCount;

			const $productText = getItemText($callActionCount)
			// Update progress text based on tier descriptions
			if ($callActionCount > 0) {
				$callActionText = 'Add ' + $callActionCount + ' more ' + $productText + ' to Get ' + $discount + ' off';
			} else {
				// We've reached or exceeded the highest tier
				const highestTier = sortedTiers[sortedTiers.length - 1];
				$callActionText = 'Congratulations! You get ' + discount_tiers[highestTier] + '% Off';
			}
			$('.bb-progress-text').text($callActionText);
			// Update add to cart button text
			if ($newBundleProductsCount >= parseInt(sortedTiers[0])) {
				$('.bb-total-price-container').removeClass('visually-hidden');
				$('.bb-add-to-cart').addClass('bb-add-to-cart-active');

				if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
					$('.bb-add-cart-text').text(strings.update_bundle_in_cart);
				} else {
					$('.bb-add-cart-text').text('Add to cart');
				}
			} else {
				$('.bb-total-price-container').addClass('visually-hidden');
				$('.bb-add-cart-text').text('Add ' + $callActionCount + ' more ' + $productText);
			}

			// Update placeholder text for remaining slots
			const lowestTier = parseInt(sortedTiers[0]);
			$callActionPlaceCount = lowestTier - $newBundleProductsCount;
			$callActionPlaceCount2 = $callActionPlaceCount + 1;
			$callActionPlaceCount3 = $callActionPlaceCount2 + 1;

			const $productText2 = getItemText($callActionPlaceCount2)
			const $productText3 = getItemText($callActionPlaceCount3)

			var $callActionPlaceholder = 'Add ' + $callActionPlaceCount + ' more ' + $productText + ' & save ' + $discount;
			var $callActionPlaceholder2 = 'Add ' + $callActionPlaceCount2 + ' more ' + $productText2 + ' & save ' + $discount;
			var $callActionPlaceholder3 = 'Add ' + $callActionPlaceCount3 + ' more ' + $productText3 + ' & save ' + $discount;

			$('.bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder);
			$('.bb-item-call-action + .bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder2);
			$('.bb-item-call-action + .bb-item-call-action + .bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder3);

			saveToBundleMetadata($variantId, 1)
		}
	}

	function saveToBundleMetadata(id, quantity = 1) {
		bundle_metadata.items[id] = bundle_metadata.items[id] || { quantity: 0 }
		bundle_metadata.items[id].quantity += quantity;
		let totalItemsInBundle = 0;

		Object.keys(bundle_metadata.items).forEach(function (variant_id) {
			if (bundle_metadata.items[variant_id].quantity > 0) {
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').addClass('bb-added-to-bundle');
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-quantity input').val(bundle_metadata.items[variant_id].quantity)
			} else {
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').removeClass('bb-added-to-bundle');
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-quantity input').val(1)
			}
			const maxQuantity = parseInt($('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').data('max'))
			if (maxQuantity > 0) {
				if (bundle_metadata.items[variant_id].quantity >= maxQuantity) {
					$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-add-product-bundle').addClass('disabled').attr('disabled', true)
				} else {
					$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-add-product-bundle').removeClass('disabled').removeAttr('disabled')
				}
			}

			totalItemsInBundle += bundle_metadata.items[variant_id].quantity
		})
		// Get the highest tier
		const highestTier = Object.keys(discount_tiers).sort((a, b) => b - a)[0];
		const hasFreeGift = gift_count[highestTier] > 0;

		// Determine the maximum items allowed in the bundle
		const maxItems = hasFreeGift ? parseInt(highestTier) + 1 : parseInt(highestTier);

		if (totalItemsInBundle >= maxItems) {
			$('.bb-add-product-bundle').addClass('disabled').attr('disabled', 'disabled');
		} else {
			$('.bb-add-product-bundle').removeClass('disabled').removeAttr('disabled');
		}


		 const currentQuantityInBundle = getBundleItemQuantity(id);
		 var $newTarget = $('.card-wrapper[data-variant-id="' + id + '"]');

		const maxAllowedQuantity = parseInt($newTarget.data('max')) || 2;
		if(currentQuantityInBundle <= 0 || currentQuantityInBundle >= maxAllowedQuantity) {
			$newTarget.find('.quick-add').addClass('bb-quantity-hidden');
		} else {
			$newTarget.find('.quick-add').removeClass('bb-quantity-hidden');
		}
		if(currentQuantityInBundle < maxAllowedQuantity) {
			$newTarget.find('.bb-add-product-bundle').removeClass('bb-item-remove-cart');
		} else {
			$newTarget.find('.bb-add-product-bundle').addClass('bb-item-remove-cart');
		}
		$newTarget.find('.quick-add input').val(currentQuantityInBundle);
	}

	function getBundleItemQuantity(id) {
		bundle_metadata.items[id] = bundle_metadata.items[id] || { quantity: 0 }
		return bundle_metadata.items[id].quantity
	}

	$(document).on('click', '.bb-add-product-bundle:not(.bb-item-remove-cart)', function () {
		addNormalItem($(this))
	});

	$(document).on('click', '.bb-add-to-cart-active', function () {
		addToCart();
	});

	function resetBundle() {
		document.querySelector('.bb-added-items-content').innerHTML = document.querySelector('#bb-added-items-template').innerHTML;

		document.querySelectorAll('.bb-free-bag-item').forEach(elem => {
			elem.classList.remove('bb-added-to-bundle')
			elem.querySelector('.bb-add-product-bundle')?.classList.remove('disabled');
		});

		const current_url = new URL(window.location.href);
		current_url.searchParams.delete('edit');
		window.history.replaceState(null, '', current_url);
		bundle_item = null;


		Object.keys(bundle_metadata.items).forEach(itemId => {
			const currentQuantity = getBundleItemQuantity(itemId);

			if (currentQuantity > 0 && (typeof bundle_metadata_original?.items?.[itemId]?.quantity === "undefined")) {
				saveToBundleMetadata(itemId, -currentQuantity)
			}
		});

		$('#total_bundle_products').val(0);
		$('.bb_products_in_bundle').html(0);
		$('.bb-total-price-container').addClass('visually-hidden');
	}

	function addToCart() {
		const _timestamp = new Date().getTime();
		var $data = [];

		// Determine if free gift is applicable based on current tier
		const currentTier = getCurrentTier();
		const hasFreeGift = currentTier && gift_count[currentTier] > 0;

		// Count products excluding free gifts
		if (hasFreeGift) {
			var productsInBundle = -1; // Deduct one for the free gift
		} else {
			var productsInBundle = 0;
		}

		const parentProductJson = JSON.parse($('script#parent-product-json').html());
		let childIds = [];
		let childProductNames = [];

		$('.bb-item-active').each(function () {
			var $this = $(this);
			const $variant = $this.data('variant-id');
			const $name = $this.data('name') + '|' + $this.data('type') + '||' + $this.data('image');
			$data.push({
				'quantity': 1,
				'id': $variant,
				properties: {
					_bundle_product: 'Yes',
					_unique_bundle_id: _timestamp,
				}
			});

			childIds.push($variant);
			childProductNames.push($name);
			productsInBundle++;
		});

		// Find the variant of parent product that suites for number of productsInBundle
		const parentVariant = parentProductJson.variants.find(variant => productsInBundle === parseInt(variant.title.split('-')[0]))
		$data.push({
			'quantity': 1,
			'id': parentVariant.id,
			properties: {
				_bundle_product: 'Yes',
				_unique_bundle_id: _timestamp,
			}
		});

		const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		const sections = cart_holder.getSectionsToRender().map((section) => section.id);
		cart_holder.setActiveElement(document.getElementById('CartDrawer'));
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: {
				items: $data,
				sections,
				sections_url: window.location.pathname + (window.location.search || '')
			},
			success: function (response) {
				if (response.status) {
					alert(response.description || 'An error has occurred.')
					return;
				}

				let cartAddResponse = response;
				if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
					let updates = {};
					updates[bundle_key] = 0;

					fetch(window.Shopify.routes.root + 'cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							updates, sections,
							sections_url: window.location.pathname + (window.location.search || '')
						})
					}).then(response => {
						return response.json();
					}).then(response => {
						if (cart_holder && cart_holder.classList.contains('is-empty')) {
							cart_holder.classList.remove('is-empty');
						}
						cart_holder.renderContents(response);

						showHideBundleActions();
					})
						.catch((error) => {
							console.error('Error:', error);
						});
				} else {
					if (cart_holder && cart_holder.classList.contains('is-empty')) {
						cart_holder.classList.remove('is-empty');
					}
					cart_holder.renderContents(response);
				}
			},
			error: function (response, a, b) {
				if (response) {
					alert(response?.responseJSON?.description || 'An error has occurred.')
					return;
				}
			},
			complete: function (data) {
				resetBundle();
			}
		});
	}

	$(document).on('click', '.remove-bb-item', function () {
		var $this = $(this),
			$target = $this.closest('.bb-item-active'),
			$variantId = $target.data('variant-id'),
			$insertPoint = $('.bb-item-active + .bb-item-placeholder'),
			$count = $('.bb-item-active').length;
		$('.bb-added-to-bundle[data-variant-id="' + $variantId + '"] .bb-item-remove-cart').removeClass('bb-item-remove-cart');
		// Get tier information for display
		const tiers = Object.keys(discount_tiers).sort((a, b) => parseInt(a) - parseInt(b));

		// Determine correct placeholder based on configuration
		var $html;

		// Check if free gift is applicable
		const hasFreeGift = gift_count[tiers[tiers.length - 1]] > 0;

		// Check if free gift has been removed before other products. If it has then count must remain the same
		if($count > 0 && $('.bb-added-item:first-of-type').hasClass('bb-item-placeholder')) {
			$count = $count + 1;
		}
		var $count_index = $count - 1;
		if (hasFreeGift) {
			if ($count == parseInt(tiers[tiers.length - 1]) + 1) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span><span>' + discount_tiers[tiers[tiers.length - 1]] + '% Off</span></div><p>Select Product</p></div>';
			} else if ($count == parseInt(tiers[tiers.length - 2]) + 1) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span><span>' + discount_tiers[tiers[tiers.length - 2]] + '% Off</span></div><p>Select Product</p></div>';
			} else if ($count == parseInt(tiers[0]) + 1) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span><span>' + discount_tiers[tiers[0]] + '% Off</span></div><p>Select Product</p></div>';
			} else {
				$html = '<div class="bb-added-item bb-item-placeholder"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span></div><p>Select Product</p></div>';
			}
		} else {
			if ($count == parseInt(tiers[tiers.length - 1])) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span><span>' + discount_tiers[tiers[tiers.length - 1]] + '% Off</span></div><p>Select Product</p></div>';
			} else if ($count == parseInt(tiers[tiers.length - 2])) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span><span>' + discount_tiers[tiers[tiers.length - 2]] + '% Off</span></div><p>Select Product</p></div>';
			} else if ($count == parseInt(tiers[0])) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span><span>' + discount_tiers[tiers[0]] + '% Off</span></div><p>Select Product</p></div>';
			} else {
				$html = '<div class="bb-added-item bb-item-placeholder"><div class="bb-added-item-image"><span class="bb-tier-key">' + $count_index + '</span></div><p>Select Product</p></div>';
			}
		}
		if ($insertPoint.length) {
			$insertPoint.before($html);
		} else {
			$('.bb-added-items-container').append($html);
		}
		$target.remove();

		var $oldBundleProductsCount = parseInt($('#total_bundle_products').val());
		$newBundleProductsCount = $oldBundleProductsCount - 1;
		$('#total_bundle_products').val($newBundleProductsCount);
		if($newBundleProductsCount == 1) {
			var $count_text = $newBundleProductsCount + ' Product';
		} else {
			var $count_text = $newBundleProductsCount + ' Products';
		}
		$('.bb_products_in_bundle').html($count_text);

		// Determine the next tier to reach based on current count
		let $nextTier = null;
		let $discount = '';
		const sortedTiers = Object.keys(discount_tiers).sort((a, b) => a - b);

		for (const tier of sortedTiers) {
			if ($newBundleProductsCount < parseInt(tier)) {
				$nextTier = tier;
				$discount = discount_tiers[tier] + '%';
				break;
			}
		}

		// If we've reached the highest tier
		if (!$nextTier) {
			$nextTier = sortedTiers[sortedTiers.length - 1];
			$discount = discount_tiers[$nextTier] + '%';
		}

		$countThreshold = parseInt($nextTier);
		$callActionCount = $countThreshold - $newBundleProductsCount;


		const $productText = getItemText($callActionCount)

		// Update progress text based on tier descriptions
		if ($callActionCount > 0) {
			$callActionText = tier_descriptions[$nextTier] ? tier_descriptions[$nextTier] : 'Add ' + $callActionCount + ' more ' + $productText + ' to Get ' + $discount + ' off';
		} else {
			// We've reached or exceeded the highest tier
			const highestTier = sortedTiers[sortedTiers.length - 1];
			$callActionText = 'Congratulations! You get ' + discount_tiers[highestTier] + '% Off';
		}

		$('.bb-progress-text').text($callActionText);

		// Update add to cart button text
		if ($newBundleProductsCount >= parseInt(sortedTiers[0])) {
			$('.bb-add-to-cart').addClass('bb-add-to-cart-active');
		} else {
			$('.bb-add-to-cart').removeClass('bb-add-to-cart-active');
			$('.bb-add-cart-text').text('Add ' + $callActionCount + ' more ' + $productText)
		}
		var $quantity = parseInt($('.bb-free-bag-item[data-variant-id="' + $variantId + '"] .bb-quantity input').val());
		if ($quantity > 1) {
			$quantity = parseInt($quantity) - 1;
			$('.bb-free-bag-item[data-variant-id="' + $variantId + '"] .bb-quantity input').val($quantity);
		} else {
			$('.bb-free-bag-item[data-variant-id="' + $variantId + '"]').removeClass('bb-added-to-bundle');
		}

		priceUpdate();
		saveToBundleMetadata($variantId, -1);
	});

	$(document).on('click', '.bb-quantity .bb-quantity-minus', function () {
		var $this = $(this),
			$quantityInput = $this.closest('.bb-quantity').find('input'),
			$min = $quantityInput.attr('min'),
			$quantity = $quantityInput.val();
		var $variantId = $this.closest('.bb-free-bag-item').attr('data-variant-id');
		$('.bb-added-item[data-variant-id="' + $variantId + '"]').each(function (index) {
			var $this = $(this);
			if (index == 0) {
				$this.find('.remove-bb-item').trigger('click');
			}
		});
	});

	$(document).on('click', '.bb-quantity .bb-quantity-plus', function () {
		var $this = $(this),
			$quantityInput = $this.closest('.bb-quantity').find('input'),
			$max = parseInt($quantityInput.attr('max')),
			$quantity = parseInt($quantityInput.val());
		if ($quantity < $max && getBundleItemQuantity(parseInt($this.closest('[data-variant-id]').data('variant-id'))) < $max) {
			$quantity = parseInt($quantity) + 1;
			$quantityInput.val($quantity).trigger('change');
			$this.closest('.bb-free-bag-item').find('.bb-add-product-bundle').trigger('click');
		}
	});


	$(document).on('change input', '.card-variants-container input', function() {
		var $this = $(this),
			image = $this.data('image'),
			id = $this.data('variant-id'),
			price = $this.data('price'),
			available = $this.data('available')
			button = $this.closest('.card-wrapper').find('.bb-add-product-bundle');
		if(available) {
			button.removeClass('sold-out-variant');
		} else {
			button.addClass('sold-out-variant');
		}
		$this.closest('.card-wrapper')
			.attr('data-image', image)
			.attr('data-variant-id', id)
			.attr('data-price', price)
			.data({ image, 'variant-id': id, price });
		$this.closest('.card-wrapper').find('.card__media img').attr('src', image)
		const currentQuantityInBundle = getBundleItemQuantity(id);
		var $newTarget = $('.card-wrapper[data-variant-id="' + id + '"]');
		const maxAllowedQuantity = parseInt($newTarget.data('max')) || 2;
		if(currentQuantityInBundle == 0 || currentQuantityInBundle == maxAllowedQuantity) {
			$newTarget.find('.quick-add').addClass('bb-quantity-hidden');
		} else {
			$newTarget.find('.quick-add').removeClass('bb-quantity-hidden');
		}
		if(currentQuantityInBundle < maxAllowedQuantity) {
			$newTarget.find('.bb-add-product-bundle').removeClass('bb-item-remove-cart');
		} else {
			$newTarget.find('.bb-add-product-bundle').addClass('bb-item-remove-cart');
		}
		$newTarget.find('.quick-add input').val(currentQuantityInBundle);
	});
})()

$(document).on('click', 'a[data-section]', function(){
	var $this = $(this),
	$offset = $($this.data('section')).offset().top;
	$('html, body').animate({
		'scrollTop':$offset
	})
});

$(document).on('click', '.bb_expand_progress', function(){
	$(this).closest('.bb-progress').toggleClass('bb-view-expanded');
});

$(document).on('scroll', function(){
	if($(window).scrollTop() > 50) {
		$('.bb-progress').addClass('bb-progress-visible');
	} else {
		$('.bb-progress').removeClass('bb-progress-visible');
	}
});

$(document).on('click', '.bb-product-details', function () {
	var $this = $(this),
		$url = '/products/' + $this.attr('href'),
		$type = $this.data('type'),
		$weight = $this.data('weight'),
		$desc = $this.data('desc'),
		$variantid = $this.closest('.card-wrapper').data('variant-id'),
		$variantPrice = $this.closest('.card-wrapper').data('price'),
		$variantImage = $this.closest('.card-wrapper').data('image'),
		$productImage = $this.closest('.card-wrapper').data('product-image'),
		$productName = $this.closest('.card-wrapper').data('product-name');
	$('.bb-mobile-content img').attr('src', '');
	$('.bb-mobile-content img + img').attr('src', '');
	$('.bb-mobile-content .rte').html('');
	$('.bb-product-type .rte').html('');
	$('.bb-mobile-content .bb-add-bundle-trigger').attr('data-variant-id', '');
	$('.bb-product-title').html('');
	$('.bb-price').html('');
	$.ajax({
		type: 'GET',
		url: $url,
		dataType: 'json',
		success: function (data) {
			console.log(data.product);
			var product = data.product,
				$image = $variantImage || product.image.src,
				$variant_id = $variantid || product.variants[0].id,
				$price = $variantPrice || '$'+product.variants[0].price,
				$title = $productName || product.title;
			$('.bb-product-title').html($title);
			$('.bb-mobile-content img').attr('src', $image);
			$('.bb-product-type').html($type);
			$('.bb-mobile-content .rte').html($desc);
			$('.bb-mobile-content .bb-add-bundle-trigger').attr('data-variant-id', $variant_id);
			if ($weight == '' | $weight == ' ') {
				$('.bb-price').html('<strong>' + Shopify.formatMoney($price, '${{amount}}') + '</strong>');
			} else {
				$('.bb-price').html('<strong>' + Shopify.formatMoney($price, '${{amount}}') + '</strong> | ' + $weight);
			}
		}
	});
	return false;
});